import { StatementListSortModifierType } from "@sellar-io/api-v2/types";
import { SortType } from "../../../lists/types";

export type SellarCreditStatementSortType =
  | "createdAt_asc"
  | "createdAt_desc"
  | "supplier_asc"
  | "supplier_desc"
  | "business_asc"
  | "business_desc";

export const SellarCreditStatementSortValues: SortType<
  StatementListSortModifierType,
  SellarCreditStatementSortType
> = {
  createdAt_asc: {
    key: "createdAt_asc",
    name: "createdAt asc",
    mutation: {
      type: "createdAt",
      direction: "asc",
    },
  },
  createdAt_desc: {
    key: "createdAt_desc",
    name: "createdAt desc",
    mutation: {
      type: "createdAt",
      direction: "desc",
    },
  },
  supplier_asc: {
    key: "supplier_asc",
    name: "Supplier name (A-Z)",
    mutation: {
      type: "supplierName",
      direction: "asc",
    },
  },
  supplier_desc: {
    key: "supplier_desc",
    name: "Supplier name (A-Z)",
    mutation: {
      type: "supplierName",
      direction: "desc",
    },
  },
  business_asc: {
    key: "business_asc",
    name: "Business name (A-Z)",
    mutation: {
      type: "businessName",
      direction: "asc",
    },
  },
  business_desc: {
    key: "business_desc",
    name: "Business name (Z-A)",
    mutation: {
      type: "businessName",
      direction: "desc",
    },
  },
};
